export const MOVIE_LINE = {
  init: function movieLine() {
    // マスクのアニメーションを開始する関数（youtubeの線用）
    function startMovieMaskAnimation() {
      const movieMaskAnimate = document.getElementById('mask-rect')
      if (movieMaskAnimate) {
        movieMaskAnimate.style.animation = 'move-mask-line 3.5s ease-in-out 1s forwards' // アニメーションを適用
      }
    }

    // マスクのアニメーションを開始する関数（波線用）
    function startWaveMaskAnimation() {
      const waveMaskAnimate = document.getElementById('wave-mask-animate')
      if (waveMaskAnimate) {
        waveMaskAnimate.style.animation = 'wave-mask 3.5s ease-out both' // アニメーションを適用
      }
    }

    function startWaveMaskAnimationSp() {
      const waveMaskAnimateSp = document.getElementById('wave-mask-animate-sp')
      if (waveMaskAnimateSp) {
        waveMaskAnimateSp.style.animation = 'wave-mask 2s ease-out both' // アニメーションを適用
      }
    }

    // オブザーバーのオプション
    const options = {
      root: null, // ビューポートを基準にする
      rootMargin: '0px',
      threshold: 0, // 10%が見えたときにコールバックを実行
    }

    // コールバック関数
    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('p-top-movie_bg-line')) {
            startMovieMaskAnimation() // youtubeのlineマスクアニメーションを開始
          } else if (entry.target.classList.contains('p-top-class_top-wave')) {
            startWaveMaskAnimation() // class部分の波線のマスクアニメーションを開始
          } else if (entry.target.classList.contains('p-top-class_top-wave-sp')) {
            startWaveMaskAnimationSp() // class部分のSPの波線のマスクアニメーションを開始
          }
          observer.unobserve(entry.target) // アニメーション後に監視を停止
        }
      })
    }

    // インターセクションオブザーバーのインスタンスを作成
    const observer = new IntersectionObserver(callback, options)

    // 対象の要素を監視
    const targetMovieLine = document.querySelector('.p-top-movie_bg-line')
    const targetWaveLine = document.querySelector('.p-top-class_top-wave')
    const targetWaveLineSp = document.querySelector('.p-top-class_top-wave-sp')

    if (targetMovieLine) observer.observe(targetMovieLine)
    if (targetWaveLine) observer.observe(targetWaveLine)
    if (targetWaveLineSp) observer.observe(targetWaveLineSp)
  },
}
